import DoAPICall from './DoAPICall'

//Create session
    export async function createSession(userToken, session){
            const apiPayload = {
                httpMethod:'post',
                userToken,
                uri:'sessions',
                payLoad:{
                    sessionId:session.sessionId,
                    mno_id:session.mno_id,
                    mobileNumber:'26'+session.mobileNumber,
                    subscriberInput:session.subscriberInput,

                    menu_id:session.menu_id,
                    swscAccountNo:session.swscAccountNo,
                    transactionId:session.transactionId,
                    paymentAmount:session.paymentAmount,

                    ppTransactionId:session.ppTransactionId,
                    paymentStatus:session.paymentStatus,
                    swscReceiptNo:session.swscReceiptNo,
                    status:session.status
                },
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

//Get All session
    export async function getSessions(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'sessions',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One session
    export async function getSession(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'sessions/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update session
    export async function updateSession(userToken, session){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'sessions/'+session.session_id,
            payLoad:{
                customerJourney:session.customerJourney,
                paymentAmount:session.paymentAmount,
                response:session.response,
                menu_id:session.menu_id,
                error:session.error
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete session
    export async function deleteSession(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'sessions/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Search Payments

//Get sessions of account/mobile
    export async function getSessionsOfClient(userToken,params){
        let uriParams;
        uriParams = 'paymentsessions?client_id='+params.client_id
        if(params.customerAccount){
            uriParams = uriParams+'&customerAccount='+params.customerAccount
        }
        if(params.mobileNumber){
            uriParams = uriParams+'&mobileNumber='+params.mobileNumber
        }
        if(params.from){
            uriParams = uriParams+'&dateFrom='+params.from
        }
        if(params.to){
            uriParams = uriParams+'&dateTo='+params.to
        }
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:uriParams,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function getSessionPayment(userToken,client_id,session_id){
        const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'sessionpayment?client_id='+client_id+"&session_id="+session_id,
        payLoad:{},
        requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }


